const damApiErrorMessages = {
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    SESSION_NOT_ACTIVE: 'SESSION_NOT_ACTIVE',
    ENVIRONMENT_MISMATCH: 'ENVIRONMENT_MISMATCH',
};

export default damApiErrorMessages;
